export default {
  breakpoints: ['40em', '52em', '64em'],
  space: [0, '0.8rem', '1.6rem', '4.8rem', '6.4rem'],
  fonts: {
    heading: 'Barlow Condensed, sans-serif',
    body: 'Roboto, sans-serif'
  },
  fontSizes: [
    '1.6rem',
    '1.8rem',
    '2rem',
    '2.2rem',
    '2.4rem',
    '3.2rem',
    '5.6rem',
    '9.2rem'
  ],
  colors: {
    text: '#868e96',
    background: '#fff',
    primary: '#1C7C54',
    secondary: '#343a40',
    button: '#495057',
    nav: {
      link: 'rgba(255, 255, 255, .5)',
      linkHover: 'rgba(255, 255, 255, .75)',
      linkActive: '#fff'
    }
  }
};
